import { useMemo } from 'react'

import useMenusStore from 'src/stores/useMenusStore'
import useSelectedDashboardStore from 'src/stores/useSelectedDashboardStore'
import { findSubProductOnMenusFn } from 'src/utils/menuUtils'
import { SubProduct } from 'src/utils/product'
import useProductMatchParams from './useProductMatchParams'

export const STANDARD_DASHBOARD_NAME = 'Standard Dashboard'

const PRODUCT_WITH_SUBPRODUCT_NAME = [SubProduct.StreamingAnalytics, SubProduct.DataDownload]

const usePageSubProductTitle = (): string => {
  const selectedDashboard = useSelectedDashboardStore(s => s.selectedDashboard)
  const menus = useMenusStore(s => s.menus)
  const routeParams = useProductMatchParams()
  const subProductCode = routeParams?.params?.subProduct

  const subProductName = useMemo(() => {
    if (selectedDashboard?.name) {
      return selectedDashboard.name
    }
    if (PRODUCT_WITH_SUBPRODUCT_NAME.includes(subProductCode as SubProduct)) {
      const subProduct = findSubProductOnMenusFn({ menus, subProductCode: subProductCode || '' })
      if (subProduct) {
        return subProduct.name
      }
    }
    return STANDARD_DASHBOARD_NAME
  }, [menus, subProductCode, selectedDashboard])

  return subProductName
}

export default usePageSubProductTitle
